import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostExam = (proGradeFlag, cutoffRef, questionList) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {

        console.log(questionList)

        fetchRequest("POST", `/admin/exam`, {
            "pro_grade_flag": proGradeFlag,
            "cutoff": cutoffRef?.current?.value,
            "question": JSON.stringify(questionList),
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate("/exam")
                break
            case 400:
                if (fetchResult?.data?.error_code === "pro_grade_flag") setAlert("대상 프로 자격 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "cutoff") setAlert("커트라인 점수 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "question") setAlert("1개 이상의 문제를 입력해주세요.")
                else if (fetchResult?.data?.error_code === "problem") setAlert("입력하지 않은 지문이 있습니다.")
                else if (fetchResult?.data?.error_code === "choice") setAlert("1개 이상의 선다를 입력해주세요.")
                else if (fetchResult?.data?.error_code === "answer") setAlert("모든 문제에는 정답이 선택되어야 합니다.")
                else if (fetchResult?.data?.error_code === "point") setAlert("모든 문제에는 정수로 배점이 입력되어야 합니다.")
                else if (fetchResult?.data?.error_code === 1) setAlert("모든 배점의 합은 100점이어야 합니다.")

                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePostExam